import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import { IssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { formatPercentage } from '../../../packages/utils/numberFormatters'

export function ConditionalIssueRow({ issue }: { issue: Partial<IssueEntity> }) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    if (issue.minimumSubCondition === null) {
        return null
    }

    const minimumSubCondition = formatPercentage(issue.minimumSubCondition!, { minDecimals: 0, maxDecimals: 2, locale })

    const conditionalText = `Emissionen är villkorad att teckningsgraden uppgår till minst ${minimumSubCondition}`

    return (
        <FactsTableRow label='Villkorad teckningsgrad'>
            <Typography>{conditionalText}</Typography>
        </FactsTableRow>
    )
}
